import { render } from "./AccountSpaBookings.vue?vue&type=template&id=660aaef2"
import script from "./AccountSpaBookings.vue?vue&type=script&lang=js"
export * from "./AccountSpaBookings.vue?vue&type=script&lang=js"

import "./AccountSpaBookings.vue?vue&type=style&index=0&id=660aaef2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__